import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import ConnectedFlagsProvider from '@wix/da-react-context/pkg/flags/ConnectedFlagsProvider';
import Document from '../Document';
import SessionProvider from '../SessionProvider/SessionProvider';
const AppDocumentWrapper = ({ store, children, themeSelector, themeSkinSelector })=>{
    var _store_getState_flags, _store_getState;
    const isDebug = (_store_getState = store.getState()) === null || _store_getState === void 0 ? void 0 : (_store_getState_flags = _store_getState.flags) === null || _store_getState_flags === void 0 ? void 0 : _store_getState_flags.hasOwnProperty('redux_selector_debug');
    const reduxStabilityCheck = isDebug ? 'always' : 'never';
    useEffect(()=>{
        performance.mark('RCacheAppStartup');
    }, []);
    return /*#__PURE__*/ React.createElement(HelmetProvider, {
        context: {}
    }, /*#__PURE__*/ React.createElement(Provider, {
        store: store,
        stabilityCheck: reduxStabilityCheck
    }, /*#__PURE__*/ React.createElement(SessionProvider, null, /*#__PURE__*/ React.createElement(ConnectedFlagsProvider, null, /*#__PURE__*/ React.createElement(Document, {
        themeSelector: themeSelector,
        themeSkinSelector: themeSkinSelector
    }, children)))));
};
AppDocumentWrapper.displayName = 'AppDocumentWrapper';
export default AppDocumentWrapper;
